const pageNameKey = "gatewayServiceUsersList";

export const gatewayServiceUsersListEn = {
  [pageNameKey]: {
    displayNameLabel: "Display Name",
    usernameLabel: "Username",
    statusLabel: "Status",
    expirationDateLabel: "Expiration Date",
    createdAtLabel: "Created At",
    updatedAtLabel: "Last Modified",
    statusTextActive: "Active",
    statusTextInactive: "Inactive",
    errorChangeUserStatusApiText:
      "We couldn't change the user status, so we reverted the change. Please try again.",
    noGatewayServiceUsersFoundMessage:
      "No gateway service users could be found",
  },
};

export const gatewayServiceUsersListPtBr = {
  [pageNameKey]: {
    displayNameLabel: "Nome de exibição",
    usernameLabel: "Nome de usuário",
    statusLabel: "Status",
    expirationDateLabel: "Data de validade",
    createdAtLabel: "Criado em",
    updatedAtLabel: "Última modificação",
    statusTextActive: "Ativo",
    statusTextInactive: "Inativo",
    errorChangeUserStatusApiText:
      "Não foi possível alterar o status do usuário, então revertimos a alteração. Tente novamente.",
    noGatewayServiceUsersFoundMessage:
      "Nenhum usuário do serviço de gateway pôde ser encontrado",
  },
};

export const gatewayServiceUsersListDe = {
  [pageNameKey]: {
    displayNameLabel: "Anzeigename",
    usernameLabel: "Benutzername",
    statusLabel: "Status",
    expirationDateLabel: "Ablaufdatum",
    createdAtLabel: "Erstellt am",
    updatedAtLabel: "Zuletzt geändert",
    statusTextActive: "Aktiv",
    statusTextInactive: "Inaktiv",
    errorChangeUserStatusApiText:
      "Wir konnten den Benutzerstatus nicht ändern, daher haben wir die Änderung rückgängig gemacht. Bitte versuchen Sie es erneut.",
    noGatewayServiceUsersFoundMessage:
      "Es konnten keine Gateway-Service-Benutzer gefunden werden",
  },
};

export const gatewayServiceUsersListZhHans = {
  [pageNameKey]: {
    displayNameLabel: "显示名称",
    usernameLabel: "用户名",
    statusLabel: "状态",
    expirationDateLabel: "过期日期",
    createdAtLabel: "创建于",
    updatedAtLabel: "最后修改",
    statusTextActive: "活跃的",
    statusTextInactive: "不活跃的",
    errorChangeUserStatusApiText:
      "我们无法更改用户状态，因此我们恢复了更改。请再试一次。",
    noGatewayServiceUsersFoundMessage: "未找到网关服务用户",
  },
};

export const gatewayServiceUsersListEs = {
  [pageNameKey]: {
    displayNameLabel: "Nombre para mostrar",
    usernameLabel: "Nombre de usuario",
    statusLabel: "Estado",
    expirationDateLabel: "Fecha de vencimiento",
    createdAtLabel: "Fecha de creación",
    updatedAtLabel: "Última modificación",
    statusTextActive: "Activo",
    statusTextInactive: "Inactivo",
    errorChangeUserStatusApiText:
      "No pudimos cambiar el estado del usuario, así que revertimos el cambio. Inténtalo de nuevo.",
    noGatewayServiceUsersFoundMessage:
      "No se pudo encontrar ningún usuario del servicio de gateway",
  },
};

export const gatewayServiceUsersListIt = {
  [pageNameKey]: {
    displayNameLabel: "Nome visualizzato",
    usernameLabel: "Nome utente",
    statusLabel: "Stato",
    expirationDateLabel: "Data di scadenza",
    createdAtLabel: "Creato il",
    updatedAtLabel: "Ultima modifica",
    statusTextActive: "Attivo",
    statusTextInactive: "Inattivo",
    errorChangeUserStatusApiText:
      "Non siamo riusciti a cambiare lo stato dell'utente, quindi abbiamo annullato la modifica. Per favore riprova.",
    noGatewayServiceUsersFoundMessage: "Non sono stati trovati utenti gateway",
  },
};

export const gatewayServiceUsersListNl = {
  [pageNameKey]: {
    createdAtLabel: "Aangemaakt op",
    displayNameLabel: "Weergavenaam",
    errorChangeUserStatusApiText:
      "We konden de gebruikersstatus niet wijzigen, daarom hebben we de wijziging ongedaan gemaakt. Probeer het opnieuw.",
    expirationDateLabel: "Vervaldatum",
    statusLabel: "Status",
    statusTextActive: "Actief",
    statusTextInactive: "Inactief",
    updatedAtLabel: "Laatst gewijzigd",
    usernameLabel: "Gebruikersnaam",
    noGatewayServiceUsersFoundMessage:
      "Er konden geen gateway-servicegebruikers worden gevonden",
  },
};

export const gatewayServiceUsersListTr = {
  [pageNameKey]: {
    createdAtLabel: "Oluşturulma Tarihi",
    displayNameLabel: "Ekran adı",
    errorChangeUserStatusApiText:
      "Kullanıcı durumunu değiştiremediğimiz için değişikliği geri aldık. Lütfen tekrar deneyin.",
    expirationDateLabel: "Son kullanma tarihi",
    noGatewayServiceUsersFoundMessage:
      "Hiçbir ağ geçidi hizmeti kullanıcısı bulunamadı",
    statusLabel: "Durum",
    statusTextActive: "Aktif",
    statusTextInactive: "Etkin değil",
    updatedAtLabel: "Son Değiştirilme",
    usernameLabel: "Kullanıcı adı",
  },
};
